import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IFollowup } from "./followup";
import { IInquiry } from "./inquiry";
import { ISearchRequest } from "./search-request";
import { ISearchResult } from "./search-result";
import { environment } from '@env/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})

export class InquiryService {
  private api: string;
  private searchApi: string;
  private matchAPI: string;
  constructor(private httpService: HttpClient)
  {
    this.api = environment.privateApi + "calltracker/inquiry/";// baseUrl + "inquiry/";
    this.searchApi = environment.privateApi + "calltracker/search/";
    this.matchAPI = environment.privateApi + "calltracker/matches/";
  }

  saveInquiry(inquiry: IInquiry): Observable<IInquiry> {
    return this.httpService.post<IInquiry>(this.api + 'inquiry', inquiry, httpOptions);
  }

  getInquiry(callId: number): Observable<IInquiry> {
    return this.httpService.get<IInquiry>(this.api + 'inquiry/' + callId);
  }

  saveFollowup(followup: IFollowup): Observable<IFollowup> {
    return this.httpService.post<IFollowup>(this.api + 'followup', followup, httpOptions);
  }

  getFollowups(callId: number): Observable<IFollowup[]> {
    return this.httpService.get<IFollowup[]>(this.api + 'followup/' + callId);
  }

  search(search: ISearchRequest): Observable<ISearchResult[]> {
    return this.httpService.post<ISearchResult[]>(this.searchApi + 'search', search, httpOptions);
  }

  getCsv(callIds: number[]): Observable<Blob> {
    return this.httpService.post<Blob>(this.searchApi + 'csv/', callIds, {responseType: 'blob' as 'json'});
  }

  getMatches(firstName: string, lastName: string): Observable<ISearchResult[]> {
    var name = firstName + ',' + lastName;
    return this.httpService.get<ISearchResult[]>(this.matchAPI + 'matches/' + name, httpOptions);
  }
}
